import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SessionStorageService } from './session-storage.service';
import { throwError, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { EnvironmentService } from '../services/environment.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorReportingService {
  private http = inject(HttpClient);
  private ss = inject(SessionStorageService);
  private envSvc = inject(EnvironmentService);

  private environment;
  private baseUrl: string;
  private app: string;
  private org: string;

  constructor() {
    this.environment = this.envSvc.get();
    this.baseUrl = this.environment.apiBase;
    this.org = this.environment.org;
    this.app = this.ss.get('currentApp') || this.environment.defaultApp || 'pp';
    this.org = this.environment.org || 'basev2';
  }

  handleError(error, log = true) {
    let level = 'WARNING';
    const session = this.ss.get('session');
    if (log && this.environment.production) {
      if (error.status) {
        switch (error.status) {
          case 400:
            level = 'WARNING';
            break;
          case 403:
            level = 'WARNING';
            break;
          case 404:
            level = 'WARNING';
            break;
          case 500:
            level = 'ALERT';
            break;
          case 503:
            level = 'ALERT';
            break;
        }
      }
      this.loggingReport(level, error.message, error, session).subscribe();
    }
    console.error('Error occurred:', error);
    return throwError(() => error || 'Server error');
  }

  loggingReport(level, message, data, session): Observable<void> {
    const reqHeaders = new HttpHeaders()
      .set('X-RB-S', session)
      .set('X-RB-I', this.app)
      .set('X-RB-O', this.org)
      .set('Content-Type', 'application/json');
    const url = `${this.baseUrl}/Admin/WriteLogData`;
    const payload = {
      level: level,
      message: message,
      category: 'FRONT_END',
      data: data,
      status: data.status,
    };

    return this.http.post<void>(url, payload, { headers: reqHeaders }).pipe(
      map(res => {
        return res;
      }),
      catchError((error: any) => {
        return throwError(() => error.error || 'Server error');
      })
    );
  }
}
